import { NgModule } from '@angular/core';

import { CountryPipe } from './country.pipe';

@NgModule({
  declarations: [CountryPipe],
  exports: [CountryPipe]
})
export class CountryModule {}
